import { Dialog } from "@mui/material";
import { useScale } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import I18n from "features/shared/i18n";

interface ChildUserLimitModalProps {
  open: boolean;
  onClose: () => void;
  limit: number;
}

export const ChildUserLimitModal = ({ open, onClose, limit }: ChildUserLimitModalProps) => {
  const { scale } = useScale();

  const handleClose = () => {
    onClose();
  };

  const message = I18n.t("MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE", { limit });

  return (
    <Dialog
      fullScreen
      open={open}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el w-[600px] border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white">
              <ParentCloseBtn close={handleClose} />
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                <span className="material-symbols-outlined !text-[54px] text-red-100">warning</span>
                <h2 className="text-[33px] text-textcolor-black whitespace-nowrap">
                  {I18n.t("MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE")}
                </h2>
              </div>
              <div className="flex-col-view items-start py-4">
                {message.split("\n").map((line, index) => (
                  <p key={index} className="text-body text-textcolor-black text-[24px] mb-2">
                    {line}
                  </p>
                ))}
              </div>

              <div className="flex-row-el flex-center gap-4 mt-4">
                <button
                  onClick={handleClose}
                  className="flex-row-el items-center justify-center w-[160px] py-3 bg-white border border-gray2-60 text-textcolor-black rounded-[12px] text-[24px] cursor-pointer hover:bg-gray2-20 transition-all"
                >
                  {I18n.t("MSG_CLOSE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
